import { getPlayers, postPlayer, putPlayer } from '../../../Api/services/backoffice';

export const key = 'player';

const entityName = {
  singular: 'Player',
  plural: 'Players',
};

const queries = {
  list: { key, fn: getPlayers },
  detail: { key },
};

const mutations = {
  create: postPlayer,
  update: putPlayer,
};

const fields = {
  table: [
    { key: 'name', label: 'Nome' },
    { key: 'active', label: 'Status', mustRender: { componentType: 'status' } },
  ],
};

export const listConfig = {
  title: entityName.plural,
  tableFields: fields.table,
  searchFields: fields.search,
  queryConfig: queries.list,
};

export const createConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.create,
};

export const updateConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.update,
  queryConfig: queries.detail,
};
